import React, { useEffect } from 'react';
import { useCloseOnEscape } from '../../hooks/useCloseOnEscape';
import './LogoutConfirmModal.css';

const LogoutConfirmModal = ({ isOpen, onClose, onConfirm, isLoggingOut }) => {
  useCloseOnEscape(isOpen && !isLoggingOut, onClose);

  useEffect(() => {
  }, [isOpen, isLoggingOut]);

  if (!isOpen) {
    return null;
  }
  

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  
  const handleCloseClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onClose();
  };
  
  const handleCancelClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onClose();
  };

  return (
    <div 
      className="logout-modal-overlay" 
      onClick={handleOverlayClick}
      style={{ 
        zIndex: 99999,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <div className="logout-modal" onClick={(e) => e.stopPropagation()}>
        <div className="logout-modal-content">
          <div className="logout-modal-header">
            <h2 className="logout-modal-title">Confirm Logout</h2>
            <button 
              className="logout-modal-close" 
              onClick={handleCloseClick}
              aria-label="Close modal"
              type="button"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path 
                  d="M18 6L6 18M6 6l12 12" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round"
                />
              </svg>
            </button>
          </div>
          
          <div className="logout-modal-body">
            <p className="logout-modal-message">
              Are you sure you want to logout? You'll need to sign in again to access your account.
            </p>
          </div>
          
          <div className="logout-modal-actions">
            <button
              className="logout-modal-button cancel-button"
              onClick={handleCancelClick}
              disabled={isLoggingOut}
              type="button"
            >
              Cancel
            </button>
            <button
              className="logout-modal-button confirm-button"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (onConfirm && typeof onConfirm === 'function') {
                  onConfirm();
                } else {
                }
              }}
              disabled={isLoggingOut}
              type="button"
              style={{ cursor: isLoggingOut ? 'not-allowed' : 'pointer' }}
            >
              {isLoggingOut ? 'Logging out...' : 'Logout'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoutConfirmModal;

